import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'lean-list',
  templateUrl: './lean-list.component.html',
  styleUrls: ['./lean-list.component.scss']
})

export class LeanListComponent implements OnInit {

  public _items = [];
  @Input() column = 1;
  @Input() editMode = false;

  constructor(protected sanitizer: DomSanitizer) {

  }

  @Input()
  set items(_items: any) {
    if (_items !== null && _items !== undefined) {
      this._items = _items;
    }
  }

  ngOnInit() {

  }

  pipeHtml(value: any) {
    if (value == undefined) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

}
